"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countSubscriptionUsers = countSubscriptionUsers;
exports.gbpMonthlySubscriptionTotal = gbpMonthlySubscriptionTotal;
exports.isSubscriptionCancelled = isSubscriptionCancelled;
exports.subscriptionEnd = subscriptionEnd;
exports.hasSubscriptionEnded = hasSubscriptionEnded;
exports.isSubscriptionActive = isSubscriptionActive;
exports.isSubscriptionPaymentOverdue = isSubscriptionPaymentOverdue;
exports.intervalInYears = intervalInYears;
exports.priceIntervalTotal = priceIntervalTotal;
exports.lineItemTotalPerYear = lineItemTotalPerYear;
const utils_1 = require("./utils");
function countSubscriptionUsers(subscriptions) {
    const userIds = subscriptions.map(([, , ref]) => (0, utils_1.userIdFromSubcollectionRef)(ref));
    return userIds ? new Set(userIds).size : undefined;
}
function gbpMonthlySubscriptionTotal(allProductPrices, subscriptions) {
    return subscriptions.reduce((total, [_, sub]) => {
        var _a, _b;
        const subProductId = sub.product.id;
        const subPriceId = sub.price.id;
        const priceTiers = (_b = (_a = allProductPrices === null || allProductPrices === void 0 ? void 0 : allProductPrices[subProductId]) === null || _a === void 0 ? void 0 : _a.find(([priceId]) => priceId === subPriceId)) === null || _b === void 0 ? void 0 : _b[1].tiers;
        return (total +
            sub.items.reduce((total, item) => total + lineItemTotalPerYear(item.price, item.quantity, priceTiers !== null && priceTiers !== void 0 ? priceTiers : []) / 12 / 100, // `unit_amount` is saved in pence
            0));
    }, 0);
}
function isSubscriptionCancelled(subscription) {
    return Boolean(subscription.ended_at || subscription.cancel_at);
}
function subscriptionEnd(subscription) {
    var _a, _b, _c;
    return ((_c = (_b = (_a = subscription.ended_at) !== null && _a !== void 0 ? _a : subscription.cancel_at) !== null && _b !== void 0 ? _b : (subscription.status === 'trialing' ? subscription.trial_end : undefined)) !== null && _c !== void 0 ? _c : subscription.current_period_end);
}
function hasSubscriptionEnded(subscription, now = Date.now()) {
    return subscriptionEnd(subscription).toMillis() <= now;
}
function isSubscriptionActive({ status }) {
    switch (status) {
        case 'active':
        case 'past_due':
        case 'incomplete':
            return true;
        default:
            return false;
    }
}
function isSubscriptionPaymentOverdue({ status }) {
    switch (status) {
        case 'past_due':
        case 'unpaid':
        case 'incomplete':
            return true;
        default:
            return false;
    }
}
function intervalInYears(interval) {
    switch (interval) {
        case 'day':
            return 1 / 365;
        case 'week':
            return 1 / 52;
        case 'month':
            return 1 / 12;
        case 'year':
            return 1;
    }
}
function priceIntervalTotal(price, quantity, priceTiers = []) {
    var _a, _b, _c, _d, _e;
    switch (price.tiers_mode) {
        case 'graduated':
            return ((_a = price.tiers) !== null && _a !== void 0 ? _a : priceTiers).reduce(({ total, quantityRemaining }, tier, tierIndex, allTiers) => {
                var _a, _b, _c, _d, _e;
                const previousTierUpTo = (_b = (_a = allTiers[tierIndex - 1]) === null || _a === void 0 ? void 0 : _a.up_to) !== null && _b !== void 0 ? _b : 0;
                const quantityMatchingThisTier = Math.min(quantityRemaining, ((_c = tier.up_to) !== null && _c !== void 0 ? _c : Infinity) - previousTierUpTo);
                return quantityRemaining > 0
                    ? {
                        total: total +
                            ((_d = tier.flat_amount) !== null && _d !== void 0 ? _d : 0) +
                            quantityMatchingThisTier * ((_e = tier.unit_amount) !== null && _e !== void 0 ? _e : 0),
                        quantityRemaining: quantityRemaining - quantityMatchingThisTier,
                    }
                    : { total, quantityRemaining };
            }, { total: 0, quantityRemaining: quantity }).total;
        case 'volume': {
            const tier = (_b = price.tiers) === null || _b === void 0 ? void 0 : _b.find((tier, tierIndex, allTiers) => {
                var _a, _b, _c;
                const previousTierUpTo = (_b = (_a = allTiers[tierIndex - 1]) === null || _a === void 0 ? void 0 : _a.up_to) !== null && _b !== void 0 ? _b : 0;
                return quantity > previousTierUpTo && quantity <= ((_c = tier.up_to) !== null && _c !== void 0 ? _c : Infinity);
            });
            return ((_c = tier === null || tier === void 0 ? void 0 : tier.flat_amount) !== null && _c !== void 0 ? _c : 0) + ((_d = tier === null || tier === void 0 ? void 0 : tier.unit_amount) !== null && _d !== void 0 ? _d : 0) * quantity;
        }
        default:
            return ((_e = price.unit_amount) !== null && _e !== void 0 ? _e : 0) * quantity;
    }
}
function lineItemTotalPerYear(price, quantity, priceTiers = []) {
    var _a, _b, _c, _d;
    return (priceIntervalTotal(price, quantity, priceTiers) /
        ((_b = (_a = price.transform_quantity) === null || _a === void 0 ? void 0 : _a.divide_by) !== null && _b !== void 0 ? _b : 1) /
        ((price.recurring ? intervalInYears(price.recurring.interval) : 1) *
            ((_d = (_c = price.recurring) === null || _c === void 0 ? void 0 : _c.interval_count) !== null && _d !== void 0 ? _d : 1)));
}
//# sourceMappingURL=subscriptions.js.map